import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppMainComponent } from './app.main.component';
import { AppAccessdeniedComponent } from './pages/app.accessdenied.component';
import { AppErrorComponent } from './pages/app.error.component';
import { AppNotfoundComponent } from './pages/app.notfound.component';
import { UserService } from './auth/user.service';
import { AuthGuard } from './auth/auth.guard';
import { BuildingsComponent } from './modules/public/buildings/buildings.component';
import { BuildingsDetailComponent } from './modules/public/buildings-detail/buildings-detail.component';
import { AboutComponent } from './modules/public/about/about.component';
import { FaqsComponent } from './modules/public/faqs/faqs.component';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {path: 'error', component: AppErrorComponent},
            {path: 'access', component: AppAccessdeniedComponent},
            {path: 'notfound', component: AppNotfoundComponent},
            {path: 'admin',
                resolve: { user: UserService },
                canActivate: [AuthGuard],
                component: AppMainComponent,
                children: [{ path: '', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) }]
            },
            {path: 'login',
                children: [{ path: '', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) }]
            },
            {
                path: 'register',
                children: [{ path: '', loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule) }]
            },
            {
                path: 'b',
                resolve: { user: UserService },
                canActivate: [AuthGuard],
                component: AppMainComponent,
                children: [{
                  path: '',
                  loadChildren: () => import('./modules/board/board.module').then(m => m.BoardModule)
                }]
              },
            {
                path: '',
                children: [{
                  path: '',
                  loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
                }]
            },
            {
                path: 'buildings',
                component: BuildingsComponent,
                children: [{
                  path: 'buildings',
                  loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
                }]
            },
            {
                path: 'buildings-detail',
                component: BuildingsDetailComponent,
                children: [{
                  path: 'buildings-detail',
                  loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
                }]
            },
            {
                path: 'about',
                component: AboutComponent,
                children: [{
                  path: 'about',
                  loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
                }]
            },
            {
                path: 'faqs',
                component: FaqsComponent,
                children: [{
                  path: 'faqs',
                  loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
                }]
            },
            {path: '**', redirectTo: '/notfound'},
        ], {scrollPositionRestoration: 'enabled', useHash: false, onSameUrlNavigation: 'reload'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
